var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17153",
    "data-name": "Group 17153",
    transform: "translate(-378 -279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(378 279)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "translate(317 280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16735",
    "data-name": "Group 16735",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8311",
    "data-name": "Path 8311",
    d: "M76.981,1.584a7.171,7.171,0,0,0-6.651-.016,5.656,5.656,0,0,1-4.847.191V.742A.742.742,0,0,0,64,.742V17.058a.742.742,0,0,0,1.483,0V10.765a7.383,7.383,0,0,0,2.266.363,6.972,6.972,0,0,0,3.27-.815,5.664,5.664,0,0,1,5.217-.015.742.742,0,0,0,1.112-.642V2.225A.742.742,0,0,0,76.981,1.584Z",
    transform: "translate(-64)",
    fill: "#3f2566"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationality);
export default __webpack_public_path__ + "static/media/Nationality.8e6c7263cfa90110a98a87a6cb9e8c88.svg";
export { ForwardRef as ReactComponent };